var map = {
	"./Stadium/Casino-caliente-banner.jpg": 542,
	"./Stadium/bannerCocacola.jpg": 543,
	"./Stadium/bannerMcDonalds.jpg": 544,
	"./Stadium/bannerWingsStop.jpg": 545,
	"./Stadium/cocacola_palco.jpg": 546
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1209;